// Names of instrumented components

// Buttons
export const FEEDBACK_BUTTON = 'Feedback button';
export const RUN_QUERY_BUTTON = 'Run query button';
export const THEME_CHANGE_BUTTON = 'Theme change button';
export const SELECT_THEME_BUTTON = 'Select theme button';
export const QUERY_MORE_INFO_BUTTON = 'Query more info button';
export const JSON_SCHEMA_COPY_BUTTON = 'JSON schema copy button';
export const RUN_HISTORY_ITEM_BUTTON = 'Run history item button';
export const SHARE_QUERY_COPY_BUTTON = 'Share query copy button';
export const ACCESS_TOKEN_COPY_BUTTON = 'Access token copy button';
export const VIEW_HISTORY_ITEM_BUTTON = 'View history item button';
export const SIDEBAR_HAMBURGER_BUTTON = 'Sidebar hamburger button';
export const CODE_SNIPPETS_COPY_BUTTON = 'Code snippets copy button';
export const VIEW_ALL_PERMISSIONS_BUTTON = 'View all permissions button';
export const EXPORT_HISTORY_ITEM_BUTTON = 'Export history item button';
export const DELETE_HISTORY_ITEM_BUTTON = 'Delete history item button';
export const RESPONSE_HEADERS_COPY_BUTTON = 'Response headers copy button';
export const DOWNLOAD_POSTMAN_COLLECTION_BUTTON = 'Download postman collection button';
export const REMOVE_RESOURCE_FROM_COLLECTION_BUTTON = 'Remove resource from collection button';
export const QUERY_COPY_BUTTON = 'Query copy button';
export const SETTINGS_BUTTON = 'Settings button';
export const HELP_BUTTON = 'Help button';
export const SIGN_IN_BUTTON = 'Sign in button';
export const SIGN_IN_WITH_OTHER_ACCOUNT_BUTTON = 'Sign in with other account button';
export const REVOKE_PERMISSION_CONSENT_BUTTON = 'Revoke consent to permissions button'
export const UPLOAD_COLLECTIONS_BUTTON = 'Upload collections button';
export const FILTER_PERMISSIONS_BUTTON = 'Filter permissions button';
export const NOTIFICATION_BANNER_DISMISS_BUTTON = 'Notification banner dismiss button'

// List items
export const HISTORY_LIST_ITEM = 'History list item';
export const RESOURCES_LIST_ITEM = 'Resources list item';
export const SAMPLE_QUERY_LIST_ITEM = 'Sample query list item';
export const ADD_RESOURCE_TO_COLLECTION_LIST_ITEM = 'Add resource to collection list item';

// Tabs
export const HISTORY_TAB = 'History tab';
export const JSON_SCHEMA_TAB = 'JSON schema tab';
export const SHARE_QUERY_TAB = 'Share query tab';
export const ACCESS_TOKEN_TAB = 'Access token tab';
export const REQUEST_BODY_TAB = 'Request body tab';
export const CODE_SNIPPETS_TAB = 'Code snippets tab';
export const ADAPTIVE_CARDS_TAB = 'Adaptive cards tab';
export const REQUEST_HEADERS_TAB = 'Request headers tab';
export const EXPAND_RESPONSE_TAB = 'Expand response tab';
export const RESPONSE_PREVIEW_TAB = 'Response preview tab';
export const RESPONSE_HEADERS_TAB = 'Response headers tab';
export const TOOLKIT_COMPONENT_TAB = 'Toolkit component tab';
export const MODIFY_PERMISSIONS_TAB = 'Modify permissions tab';
export const KEYBOARD_COPY_TABS = {
  'access-tokens-tab': 'Access token tab',
  'response-tab': 'Response preview tab',
  'response-headers-tab': 'Response headers tab',
  'csharp-tab': 'Csharp tab',
  'java-tab': 'Java tab',
  'javascript-tab': 'Javascript tab',
  'go-tab': 'Go tab',
  'powershell-tab': 'Powershell tab',
  'JSON-schema-tab': 'JSON schema tab',
  'request-body-tab': 'Request body tab'
}

// Dropdowns
export const VERSION_CHANGE_DROPDOWN = 'Version change dropdown';
export const QUERY_URL_AUTOCOMPLETE_DROPDOWN = 'Query URL autocomplete dropdown';

// Links
export const DOCUMENTATION_LINK = 'Documentation link';
export const AUTOCOMPLETE_DOCUMENTATION_LINK = 'Autocomplete documentation link';
export const RESOURCE_DOCUMENTATION_LINK = 'Resource documentation link';
export const REPORT_AN_ISSUE_LINK = 'Report an issue link';
export const OFFICE_DEV_PROGRAM_LINK = 'Office dev program link';
export const GRAPH_TOOLKIT_PLAYGROUND_LINK = 'Graph toolkit playground link';
export const MICROSOFT_APIS_TERMS_OF_USE_LINK = 'Microsoft APIs terms of use link';
export const MICROSOFT_PRIVACY_STATEMENT_LINK = 'Microsoft privacy statement link';
export const MICROSOFT_GRAPH_API_REFERENCE_DOCS_LINK = 'Microsoft graph API reference docs link';
export const GRAPH_EXPLORER_TUTORIAL_LINK = 'Graph Explorer Tutorial Link';
export const CODE_SNIPPET_LANGUAGES: {[language: string]: {sdk: string, doc: string}} = {
  CSharp: {
    sdk: 'C# SDK link', doc: 'C# snippet docs link'
  },
  JavaScript: {
    sdk: 'JavaScript SDK link', doc: 'JavaScript snippet docs link'
  },
  Java: {
    sdk: 'Java snippet SDK link', doc: 'Java snippet docs link'
  },
  Go: {
    sdk: 'Go snippet SDK link', doc: 'Go snippet docs link'
  },
  Powershell: {
    sdk: 'PowerShell snippet SDK link', doc: 'PowerShell snippet docs link'
  },
  PHP: {
    sdk: 'PHP snippet SDK link', doc: 'PHP snippet docs link'
  }
}
export const GE_DOCUMENTATION_LINK = 'GE documentation link';
export const GITHUB_LINK = 'Github link';
export const GRAPH_DOCUMENTATION_LINK = 'Graph documentation link'
export const CONSENT_TYPE_DOC_LINK = 'Consent type doc link';
export const ADMIN_CONSENT_DOC_LINK = 'Admin consent doc link';
export const MICROSOFT_GRAPH_PERMISSIONS_REFERENCE_DOCS_LINK = 'Microsoft Graph permissions reference docs link';

// Actions
export const GET_SNIPPET_ACTION = 'Get snippet action';
export const FETCH_SAMPLES_ACTION = 'Fetch samples action';
export const AUTHENTICATION_ACTION = 'Authentication action';
export const GET_ADAPTIVE_CARD_ACTION = 'Get adaptive card action';
export const FETCH_PERMISSIONS_ACTION = 'Fetch permissions action';
export const MONACO_EDITOR_FORMAT_JSON_ACTION = 'Monaco editor format JSON action';
export const LAUNCH_FEEDBACK_POPUP_ACTION = 'Launch feedback popup action';
export const DOWNLOAD_COLLECTION_PERMISSIONS_BUTTON = 'Download collection permissions button';

// Component names
export const NOTIFICATION_COMPONENT = 'Notification'
